"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Input = require("./Input.style");
var _ArrowButtonRight = _interopRequireDefault(require("@berlitz/streamline-icons/lib/bold/52-Arrows-Diagrams/01-Arrows/ArrowButtonRight"));
var _reactInputMask = _interopRequireDefault(require("react-input-mask"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var Input = function Input(_ref) {
  var ariaDescribedby = _ref.ariaDescribedby,
    autocomplete = _ref.autocomplete,
    button = _ref.button,
    defaultValue = _ref.defaultValue,
    disabled = _ref.disabled,
    ghost = _ref.ghost,
    id = _ref.id,
    light = _ref.light,
    invalid = _ref.invalid,
    mask = _ref.mask,
    maskChar = _ref.maskChar,
    maxLength = _ref.maxLength,
    minLength = _ref.minLength,
    name = _ref.name,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    onClick = _ref.onClick,
    pattern = _ref.pattern,
    placeholder = _ref.placeholder,
    required = _ref.required,
    title = _ref.title,
    type = _ref.type,
    value = _ref.value,
    icon = _ref.icon,
    onKeyDown = _ref.onKeyDown,
    onKeyPress = _ref.onKeyPress,
    onKeyUp = _ref.onKeyUp;
  var inputProps = {
    'aria-describedby': ariaDescribedby,
    'data-key': 'max-input__field',
    autoComplete: autocomplete,
    button: button,
    defaultValue: defaultValue,
    disabled: disabled,
    ghost: ghost,
    id: id,
    light: light,
    invalid: invalid,
    maxLength: maxLength,
    minLength: minLength,
    name: name,
    onChange: onChange,
    pattern: pattern,
    placeholder: placeholder,
    required: required,
    title: title,
    type: type,
    value: value,
    onKeyDown: onKeyDown,
    onKeyPress: onKeyPress,
    onKeyUp: onKeyUp,
    onClick: onClick
  };
  return /*#__PURE__*/_react.default.createElement(_Input.Wrapper, {
    "data-key": "max-input"
  }, mask ? /*#__PURE__*/_react.default.createElement(_reactInputMask.default, {
    disabled: disabled,
    mask: mask,
    maskChar: maskChar,
    onBlur: onBlur,
    onChange: onChange,
    value: value
  }, function (maskProps) {
    return /*#__PURE__*/_react.default.createElement(_Input.StyledInput, _extends({}, inputProps, maskProps));
  }) : /*#__PURE__*/_react.default.createElement(_Input.StyledInput, inputProps), button && /*#__PURE__*/_react.default.createElement(_Input.SubmitButton, {
    onClick: onClick,
    "data-key": "max-input__submit"
  }, icon ? icon : /*#__PURE__*/_react.default.createElement(_ArrowButtonRight.default, {
    size: "xs",
    color: "brand02"
  })), icon && !button && /*#__PURE__*/_react.default.createElement(_Input.IconWrapper, null, icon));
};
Input.defaultProps = {
  ariaDescribedby: null,
  button: false,
  disabled: false,
  ghost: false,
  id: null,
  invalid: false,
  onBlur: function onBlur() {},
  onClick: function onClick() {},
  placeholder: null,
  required: false,
  mask: null,
  maskChar: null,
  icon: null
};
var _default = Input;
exports.default = _default;